import { useCallback } from 'react'
import {
  openChatHandoff,
  prefillNewConversationDraft,
  setSidebarFocus,
  useAppDispatch
} from '@axilon-apps/domains-ontology-ui-state'

export interface AskInChatTarget {
  context?: import('@axilon-apps/domains-ontology-ui-state').WorkHandoffContext
  /** Human-readable title of the task or problem. */
  title: string
  /** Result item ids to mark rejected on send (reject only). */
  itemIds?: string[]
}

/**
 * "Ask in chat" and "Reject" on a work page: open a fresh conversation in the
 * main chat rail with the item attached as a chip. Reject leaves the composer
 * empty and requires a reason, which is recorded on the item when sent.
 */
export function useChatHandoff(): {
  askInChat: (target: AskInChatTarget) => void
  rejectInChat: (target: AskInChatTarget) => void
} {
  const dispatch = useAppDispatch()
  const open = useCallback(
    (tone: 'ask' | 'reject', target: AskInChatTarget) => {
      dispatch(prefillNewConversationDraft(''))
      dispatch(setSidebarFocus(null))
      dispatch(
        openChatHandoff({
          tone,
          chipLabel: target.title,
          context: target.context,
          draft: '',
          placeholder: tone === 'reject' ? 'Why is this wrong?' : 'Ask about this…',
          rejectItemIds: tone === 'reject' ? (target.itemIds ?? []) : []
        })
      )
    },
    [dispatch]
  )
  return {
    askInChat: useCallback((target) => open('ask', target), [open]),
    rejectInChat: useCallback((target) => open('reject', target), [open])
  }
}
